import React from "react";
export const Warning: React.FC<any> = () => (
	<g stroke="none" strokeWidth="1" fillRule="evenodd">
		<polygon
			fillRule="nonzero"
			points="10.9973484 15 10.9973484 17 8.9973484 17 8.9973484 15"
		></polygon>
		<polygon
			fillRule="nonzero"
			points="10.9973484 7.99 10.9973484 14.01 8.9973484 14.01 8.9973484 7.99"
		></polygon>
		<path
			d="M10.0073484,-4.33252853e-06 C10.3817051,-0.00077865 10.7251447,0.20760042 10.8973484,0.54 L10.8973484,0.54 L19.8973484,18.54 C20.0379067,18.8376864 20.0229477,19.1854817 19.8573484,19.47 C19.6742329,19.7629855 19.3528499,19.9406914 19.0073484,19.9400536 L19.0073484,19.9400536 L1.00734839,19.9400536 C0.65489847,19.9425899 0.32711214,19.7594469 0.1445682,19.4579418 C-0.03797575,19.1564366 -0.04831706,18.781099 0.11734839,18.47 L0.11734839,18.47 L9.1173484,0.55 C9.2867986,0.21372035 9.6307902,0.0011413 10.0073484,-4.33252853e-06 Z M10.0073484,3.25 L2.63734839,18 L17.3773484,18 L10.0073484,3.25 Z"
			fillRule="nonzero"
		></path>
	</g>
);
